<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>采购日报表</span>
      </div>
    </div>
    <div>
      <div class="item-box-content" style="padding-bottom:0px;">
        <el-form label-position="right" :model="queryParams">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="日期：" label-width="45px">
                <el-date-picker
                  v-model="time"
                  style="width:100%;"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :default-time="['00:00:00','23:59:59']"
                   :clearable='false'
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="部门：" label-width="45px">
                <el-select v-model="arr" multiple @change='changeOrg' placeholder="请选择">
                  <el-option
                    v-for="(item,index) in department"
                    :key="index"
                    :label="item.orgName"
                    :value="item.orgId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="负责人：" label-width="70px">
                <el-select v-model="name" multiple placeholder="请选择" filterable>
                  <el-option
                    v-for="(item,index) in allstaff"
                    :key="index"
                    :label="item.staffCnName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="合同状态：" label-width="100px">
                <el-select v-model="valList[2].value" placeholder="请选择" filterable>
                  <el-option
                    v-for="(item,index) in contractState"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="供应商名称：" label-width="85px">
                <el-input v-model="valList[3].value"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-col :span="12">
                <el-button type="primary" @click="onSearch">搜索</el-button>
                <el-button @click="onReset">重置</el-button>
              </el-col>
              <el-col :span="12" style="text-align:right">
                <el-button @click="exportOut">导出</el-button>
              </el-col>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="box-table" :style="{height:tableHeight+'px'}">
        <el-table
          :summary-method="getSummaries"
          show-summary
          :max-height="tableHeight"
          border
          ref="tableRef"
          tooltip-effect="dark"
          :data="list"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="日期" width="100">
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.signDate || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="负责人" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.staffCnName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="所属部门" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.orgName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="合同编号" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.pcbNumber || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="供应商合同编号" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.supplierContractNumber || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="供应商名称" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.suName || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="合同金额" width="100">
            <template slot-scope="scope">
              <div>{{scope.row.contractMoney |priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="付款类型" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length">{{scope.row.payType }}</div>
            </template>
          </el-table-column>
          <el-table-column label="已付账款">
            <template slot-scope="scope">
              <div>{{scope.row.accountsPaid | priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="应付账款" width="100">
            <template slot-scope="scope">
              <div>{{scope.row.accountsPayable | priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="已到期应付账款" width="150px">
            <template slot-scope="scope">
              <div>{{scope.row.accountsDue | priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="未到期应付账款" width="150px">
            <template slot-scope="scope">
              <div>{{scope.row.accountsOutstanding | priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="已收票金额" width="100">
            <template slot-scope="scope">
              <div>{{scope.row.receivedAmount | priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="未收票金额" width="120px">
            <template slot-scope="scope">
              <div>{{scope.row.noReceivedAmount | priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="已收货金额" width="120px">
            <template slot-scope="scope">
              <div>{{scope.row.deliverMoney | priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="未收货金额" width="120px">
            <template slot-scope="scope">
              <div>{{scope.row.noDeliverMoney | priceFilterNum}}</div>
            </template>
          </el-table-column>
          <el-table-column label="合同状态">
            <template slot-scope="scope">
              <div>{{scope.row.contractState=== 1 ?'待审核': scope.row.contractState=== 2?'审核中':scope.row.contractState=== 3?'履行中' :scope.row.contractState=== 4?'已履行':scope.row.contractState=== 5?'待签署':'--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="详情">
            <template slot-scope="scope">
              <el-button type="text" @click="checkSlider(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination" >
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <!-- 查看详情 -->
    <el-slider ref="dailyPurchaseReportSliderRefs"></el-slider>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { queryReportPurchaseDay, exportReportPurchaseDay, queryPurchaseOrgName, queryOrgIdsPurchase } from '@/api/data/data'
import { isSuccess, downLoadFileBlob } from '@/util/tool'
import { contractState } from '../utils/data'
import dailyPurchaseReportSlider from '../slider/dailyPurchaseReportSlider'

export default {
  components: {
    pagination,
    'el-slider': dailyPurchaseReportSlider
  },
  mounted() {
    // 获取部门
    queryPurchaseOrgName().then(res => {
      if (isSuccess(res)) {
        this.department = res.data.obj
      }
    })
    this.addDate()
  },
  data() {
    return {
      productList: [],
      tempList: [],
      tableHeight: window.innerHeight - 445,
      queryParams: {},
      list: [],
      time: [],
      arr: [],
      name: [],
      valList: [
        { value: '', column: 'orgIds' },
        { value: '', column: 'ownIds' },
        { value: '', column: 'contractState' },
        { value: '', column: 'suName' }
      ],
      searchList: [],
      loadingTable: false, // 列表loading
      pageSize: 30, //
      currentPage: 1, // 页码
      total: -1, // 列表总数
      department: [], // 部门
      allstaff: [], // 负责人
      updateTime: '',
      contractState // 合同状态
    }
  },
  methods: {
    // 选择部门
    changeOrg(val) {
      const str = val.join(',')
      if (val) {
        queryOrgIdsPurchase(str).then(res => {
          if (isSuccess(res)) {
            this.allstaff = res.data.obj
          }
        })
      }
    },
    // 默认展示当天签订所有采购合同
    addDate() {
      const nowDate = new Date()
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      }
      const newmonth = date.month < 10 ? '0' + date.month : date.month
      const newDate = date.date < 10 ? '0' + date.date : date.date
      this.updateTime = date.year + '-' + newmonth + '-' + newDate // 当前年月
      this.time = [this.updateTime, this.updateTime]
      this.onSearch()
    },
    getSummaries(param) {
      // 合计
      const sums = []
      param.columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
        } else if (index === 6) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.contractMoney
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 8) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.accountsPaid
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 9) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.accountsPayable
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 10) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.accountsDue
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 11) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.accountsOutstanding
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 12) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.receivedAmount
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 13) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.noReceivedAmount
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 14) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.deliverMoney
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 15) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.noDeliverMoney
          }, 0)
          sums[index] = total.toFixed(2)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.searchList ? this.searchList : [],
        queryPageName: ''
      }
      queryReportPurchaseDay(this.currentPage, this.pageSize, 0, params).then(res => {
        if (isSuccess(res)) {
          this.list = res.data.obj.records
          this.total = res.data.obj.total
          this.loadingTable = false
        }
      })
    },
    // 查询
    onSearch() {
      this.searchList = []
      if (this.time.length === 2) {
        this.searchList.push({
          value: this.time[0],
          endValue: this.time[1],
          column: 'purchaseDate'
        })
      }
      this.valList[0].value = this.arr.join(',')
      this.valList[1].value = this.name.join(',')
      if (this.valList.some(ele => ele.value) || this.time.length === 2) {
        this.pageSize = 30
        this.currentPage = 1
        this.valList.forEach(ele => {
          if (ele.value) {
            ele.collection = true
            this.searchList.push(ele)
          }
        })
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    // 重置
    onReset() {
      this.pageSize = 30
      this.currentPage = 1
      this.valList.forEach(ele => {
        delete ele.value
      })
      this.arr = []
      this.name = []
      this.searchList = []
      this.allstaff = []
      this.time = []
      this.getList()
    },
    // 导出
    exportOut() {
      const params = {
        criteriaVoList: this.searchList,
        queryPageName: ''
      }
      exportReportPurchaseDay(0, params)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    checkSlider(row) {
      this.$refs.dailyPurchaseReportSliderRefs.onInitialize(row)
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
